export default url => {
  var link = document.createElement("a");
  link.download = "";
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}